
import { Vue, Component, Watch, Prop, Model } from 'vue-property-decorator';
import AuditService from '@/services/audit.service';
import lazyInject from '@/di';


@Component({})
export default class BusinessAtagField extends Vue {
  val: any = '';

  treeData: any = [];

  @lazyInject(AuditService)
  protected auditService!: AuditService;

  @Model('change')
  value!: any;

  @Prop({
    type: String,
    default: '0',
  })
  isOnlineShop!: string;


  replaceFields = {
    children: 'children', title: 'name', key: 'amap_atag_id', value: 'amap_atag_id',
  };

  @Watch('val')
  watchInternalVal() {
    this.$emit('change', this.val);
    if (!this.val) {
      this.$emit('updateSubmittable', false);
    } else {
      this.$emit('updateSubmittable', true);
    }
  }

  @Watch('value')
  watchValue() {
    this.val = this.value;
    if (this.value) {
      this.val = Number(this.value);
    }
  }


  changeVal(e: any) {
    this.val = e;
  }

  async getBossIdInfo() {
    const res = await this.auditService.mainBusinessAtagList({ isOnlineShop: this.isOnlineShop }) as any;
    if (res) {
      const _res: any = res;
      _res[0].disabled = true;
      this.treeData = _res;
    }
  }

  mounted() {
    this.watchValue();
    // this.$emit('updateSubmittable', true);
    this.getBossIdInfo();
  }
}
